import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "imgDialog" }
const _hoisted_2 = { class: "imgDialog-header" }
const _hoisted_3 = { class: "previewImage" }
const _hoisted_4 = ["src"]

import { toRefs, ref, onMounted, watch, onUnmounted } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'preview',
  props: {
  previewImage: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "imgDialog-title" }, "图片预览", -1)),
      _createElementVNode("span", {
        class: "imgDialog-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, "X")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        src: __props.previewImage,
        alt: ""
      }, null, 8, _hoisted_4)
    ])
  ]))
}
}

})